"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnexDumperOptions = void 0;
class EnexDumperOptions {
    constructor(resources = true, exportApplication = 'EnexDumper', exportApplicationVersion = '0.0.1', dateFormat = "yyyyMMdd'T'HHmmss'Z'") {
        this.resources = resources;
        this.exportApplication = exportApplication;
        this.exportApplicationVersion = exportApplicationVersion;
        this.dateFormat = dateFormat;
    }
}
exports.EnexDumperOptions = EnexDumperOptions;
